import Button from "../../components/button";
import Navbar from "../../components/navbar";
import CampaignUpdates from "./reuseableComponents/campaignUpdates";
import { useState } from "react";
import share from "../../assets/icons/share.svg";
import ShareCampaign from "./reuseableComponents/shareCampaign";
import updatesIcon from "../../assets/icons/updatesIcon.svg";
import heartIcon from "../../assets/icons/whiteDonate.svg";
import illustration from "../../assets/images/donation-illustration.svg";
import Donations from "./reuseableComponents/donationList";
import CampaignComments from "./reuseableComponents/comments";
import { useCampaignDetail, useCampaignUpdates } from "../reuseableEffects";
import { Link, useParams } from "react-router-dom";
import Spinner from "../../components/Spinners/Spinner";
import { useSelector } from "react-redux";
import arrowIcon from "../../assets/icons/goBackArrow.svg";

const CampaignDetail = ({campaign_reference}) => {

    const [showUpdatesModal, setShowUpdatesModal] = useState(false);
    const [ShareModal, setShareModal] = useState(false);

    const { campaignReference } = useParams();
    const campaignDetail = useCampaignDetail(campaignReference);
    // console.log(campaignDetail)
    
    const updates = useCampaignUpdates(campaignReference);

    const loading = useSelector((state) => state.user.loading);
    document.title = `${loading? "Mosquepay" : campaignDetail?.title}`

    // const formatDate = (dateStr) => {
    //   const dateObj = new Date(dateStr);

    //   const getDaySuffix = (day) => {
    //     if (day > 3 && day < 21) return 'th'; // For 11th - 20th
    //     switch (day % 10) {
    //       case 1: return 'st';
    //       case 2: return 'nd';
    //       case 3: return 'rd';
    //       default: return 'th';
    //     }
    //   };

    //   const day = dateObj.getDate();
    //   const daySuffix = getDaySuffix(day);

    //   const monthNames = [
    //     "January", "February", "March", "April", "May", "June",
    //     "July", "August", "September", "October", "November", "December"
    //   ];
    //   const month = monthNames[dateObj.getMonth()];
    //   const year = dateObj.getFullYear();

    //   return `${day}${daySuffix} ${month}, ${year}`;
    // };


    const formatDate = (dateStr) => {
  if (!dateStr || typeof dateStr !== "string") return "Invalid date input";

  let day, month, year;
  dateStr = dateStr.trim();

  if (dateStr.includes("-")) {
    // Format: YYYY-MM-DD
    [year, month, day] = dateStr.split("-").map(Number);
  } else if (dateStr.includes("/")) {
    // Format: DD/MM/YYYY
    [day, month, year] = dateStr.split("/").map(Number);
  } else {
    return "Invalid date format";
  }

  // Validate numbers
  if (!day || !month || !year || isNaN(day) || isNaN(month) || isNaN(year)) {
    return "Invalid date values";
  }

  const dateObj = new Date(year, month - 1, day);
  if (isNaN(dateObj)) return "Invalid date";

  const getDaySuffix = (d) => {
    if (d > 3 && d < 21) return "th";
    switch (d % 10) {
      case 1:
        return "st";
      case 2:
        return "nd";
      case 3:
        return "rd";
      default:
        return "th";
    }
  };

  const daySuffix = getDaySuffix(day);

  const monthNames = [
    "January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
  ];

  const monthName = monthNames[month - 1];

  return `${day}${daySuffix} ${monthName}, ${year}`;
};



    const formattedAmountRaised = campaignDetail?.amount_raise?.replace(/,/g, "");
    const formattedAmount = campaignDetail?.amount?.replace(/,/g, "");

    const percentage = formattedAmount > 0 ? `${((formattedAmountRaised || 0) / formattedAmount) * 100}%` : "0%";

    const campaignImageURL = "https://mosquepay.org/mosquepaynew/assets/img/campaigns/";
    
    const viewUpdates = () => {
      setShowUpdatesModal(true);
    };

    const closeUpdates = () => {
        setShowUpdatesModal(false);
    };

    const showShareOptions = () => {
      setShareModal(true);
    };

    const closeShareOptions = () => {
      setShareModal(false);
  };

  // Function to calculate days left
//   const calculateDaysLeft = (endDate) => {
//     const today = new Date();
//     const end = new Date(endDate);
//     const timeDiff = end - today;
//     const daysLeft = Math.ceil(timeDiff / (1000 * 60 * 60 * 24)); // Convert milliseconds to days
//     return daysLeft > 0 ? daysLeft : 0; // Return 0 if the campaign has ended
// };

//     const daysLeft = calculateDaysLeft(campaignDetail?.end_date);

    const campaignVideo = campaignDetail?.video_url;
    const videoID = campaignVideo ? campaignVideo.split("v=")[1] : null;

    
  const isAuthenticated = useSelector((state) => state.user.isAuthenticated);

    return (
      <div className="grid gap-10 pt-5 pb-32">
        <Spinner loading={useSelector((state) => state.user).loading} />
        <Navbar />
        <div className="px-4 md:px-12 ">
          {isAuthenticated ? (
            <div className="mb-4 md:hidden">
              <Link
                to={"/dashboard"}
                className="flex gap-2 items-center w-fit cursor-pointer rounded-md"
              >
                <img src={arrowIcon} alt="" className="h-5" />
                <span className="text-brandGreen">Back to dashboard</span>
              </Link>
            </div>
          ) : null}

          <div className="grid mb-4">
            <span className="font-medium text-secondary">Campaign title:</span>
            <span className="text-sm font-bold ubuntu-font">
              {loading ? 
              <div className="h-2 w-1/3 animate-pulse bg-[#c4c4c440]"></div>
              : 
              <span>{campaignDetail?.title}</span> }
            </span>
          </div>
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-4">
            <div className="border rounded lg:col-span-7">
              {campaignDetail?.video_url === "" ? (
                <img
                  src={campaignImageURL + campaignDetail?.image}
                  alt=""
                  className="aspect-video md:aspect-auto md:h-[300px] w-full object-cover rounded"
                />
              ) : (
                <iframe
                  className="md:aspect-auto md:h-[300px] w-full rounded-md"
                  src={`https://www.youtube.com/embed/${videoID}`}
                  title="YouTube video player"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  referrerpolicy="strict-origin-when-cross-origin"
                  allowfullscreen
                ></iframe>
              )}
            </div>
            <div className="lg:col-span-5 bg-white border rounded p-4 md:p-10 flex items-center">
              <div className="w-full">
                <div className="grid gap-1">
                  {loading ? 
                  <div className="h-2 w-1/2 animate-pulse bg-[#c4c4c440]"></div>
                  : 
                  <p className="truncate font-bold">
                  &#8358;{campaignDetail?.amount_raise}{" "}
                  <span className="font-normal">raised out of</span> &#8358;
                  {campaignDetail?.amount}
                </p>
                  }
                  
                  <div className="w-full rounded-md bg-secondaryBackground p-[2px] flex items-center">
                    <div
                      className="bg-brandGreen h-[2px] w-[50%] transition-all"
                      style={{ width: percentage }}
                    ></div>
                  </div>
                  <p className="text-sm text-secondary truncate">
                    {loading ?
                    <div className="h-2 w-1/2 animate-pulse bg-[#c4c4c432]"></div>
                    :
                    <span>{campaignDetail?.txn_count} Donations</span>
                    }
                  </p>
                </div>
                <div className="mt-4 grid grid-cols-2 gap-4">
                  <div>
                    <div className="text-sm text-secondary">
                      Campaign category:
                    </div>
                    {loading ? <div className="h-2 w-1/2 animate-pulse bg-[#c4c4c432]"></div> : <div>{campaignDetail?.category}</div>}
                  </div>
                  <div>
                    <div className="text-sm text-secondary">
                      Campaign owner:
                    </div>
                    <div className="truncate">
                      {loading ? <div className="h-2 w-1/2 animate-pulse bg-[#c4c4c432]"></div> : <div>{campaignDetail?.campaign_owner}</div>}
                    </div>
                  </div>
                  <div className="col-span-2">
                    <div className="text-sm text-secondary">End date:</div>
                    {loading? 
                      <div className="h-2 w-1/2 animate-pulse bg-[#c4c4c432]"> </div> 
                      :
                      <div>{formatDate(campaignDetail?.end_date)}</div>
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="px-4 md:px-12">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
            <div className="lg:col-span-8 grid gap-10">
              <div>
                <p className="font-medium text-secondary">
                  Campaign description:
                </p>
                <p>{campaignDetail?.campaign_story}</p>

                <div className="md:w-[60%] mt-8">
                  <div className="grid grid-cols-1 md:grid-cols-5 gap-2">
                    <Link
                      to={`/donate/${campaignReference}/${encodeURIComponent(
                        campaignDetail?.title
                      )}`}
                      className="text-sm font-medium py-6 px-8 rounded bg-brandGreen text-white w-full md:col-span-3 text-center flex items-center justify-between"
                    >
                      <span>Support campaign</span>
                      <img src={heartIcon} alt="" className="h-4" />
                    </Link>

                    <div
                      onClick={showShareOptions}
                      className="text-sm font-medium py-6 px-8 md:p-4 rounded bg-black text-white w-full md:col-span-2 flex items-center justify-between md:justify-center cursor-pointer"
                    >
                      <span>Share campaign</span>
                      <img src={share} alt="" className="h-4 md:hidden" />
                    </div>
                  </div>
                </div>
              </div>

              {/* Images */}
              {/* <div>
                <div className="flex gap-2 items-center">
                  <img src={mediaIcon} alt="" className="h-[18px]" />
                  <p className="font-medium text-secondary">Images:</p>
                </div>
                <div className="grid w-full mt-2">
                  <div className="flex overflow-x-auto w-full md:grid md:grid-cols-4 gap-2">
                    <div className="min-w-40 md:w-full aspect-square rounded overflow-hidden border">
                      <img
                        src={campaignImageURL + campaignDetail?.cac_certificate}
                        alt=""
                        className="h-full w-full object-cover"
                      />
                    </div>
                    <div className="min-w-40 md:w-full aspect-square rounded overflow-hidden border">
                      <img
                        src={campaignImageURL + campaignDetail?.reference_letter}
                        alt=""
                        className="h-full w-full object-cover"
                      />
                    </div>
                    <div className="min-w-40 md:w-full aspect-square rounded overflow-hidden border">
                      <img
                        src={campaignImageURL + campaignDetail?.board_resolution}
                        alt=""
                        className="h-full w-full object-cover"
                      />
                    </div>
                    <div className="min-w-40 md:w-full aspect-square rounded overflow-hidden border">
                      <img
                        src={campaignImageURL + campaignDetail?.co7_form}
                        alt=""
                        className="h-full w-full object-cover"
                      />
                    </div>
                  </div>
                </div>
              </div> */}

              {/* Updates */}
              <div className="py-6 border-y">
                <div className="mb-4 flex justify-between items-center">
                  <div className="flex gap-2 items-center">
                    <img src={updatesIcon} alt="" className="h-[18px]" />
                    <p className="font-medium text-secondary">Updates:</p>
                  </div>
                  <p
                    className={`text-sm text-brandGreen underline cursor-pointer ${
                      updates.length < 4 ? "hidden" : "block"
                    }`}
                    onClick={viewUpdates}
                  >
                    View all updates
                  </p>
                </div>
                {updates.length === 0 ? (
                  <div>
                    <span className="text-secondary underline cursor-default">
                      {campaignDetail?.campaign_owner}
                    </span>{" "}
                    hasn't provided any updates yet.
                  </div>
                ) : (
                  <div className="grid gap-4">
                    {updates.slice(-3).map((update, index) => (
                      <div
                        key={index}
                        className="pb-4 last:pb-0 border-b last:border-0"
                      >
                        <div className="text-secondary">
                          {formatDate(update.time_in)}
                        </div>
                        <div>{update.comment}</div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
              {/* Comments */}
              <CampaignComments campaignReference={campaignReference} />
            </div>
            <div className="lg:col-span-4 relative">
              <div className="border rounded overflow-hidden p-[2px] md:sticky md:top-24">
                <div className="relative">
                  <img
                    src={illustration}
                    alt=""
                    className="transform scale-x-[-1] rounded-t"
                  />
                  <div className="absolute top-0  p-4 h-full flex items-center">
                    <div className="grid text-sm text-pretty w-[70%]">
                      <span className="font-bold">
                        The Prophet (PBUH) said:
                      </span>
                      <span>
                        Whoever guides someone to goodness will have a reward
                        like the one who did it.
                      </span>
                    </div>
                  </div>
                </div>
                <div className="relative">
                  <div className="p-4 sticky top-0 bg-secondaryBackground">
                    Recent donations.
                  </div>
                  <Donations campaignReference={campaignReference} />
                  <div className="p-2 sticky bottom-0 bg-white"></div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Fixed campaign footer */}
        <div className="px-4 md:px-12 py-4 bg-black w-full bottom-0 fixed grid md:flex md:justify-between md:items-center gap-4 text-sm">
          <div className="hidden md:grid">
            <span className="font-medium text-secondary">Campaign title:</span>
            <span className="text-white">{campaignDetail?.title}</span>
          </div>
          <div className="flex gap-4">
            <div className="w-[80%] md:w-fit">
              <Button
                buttonRole={"link"}
                buttonText={"Support this campaign"}
                icon={heartIcon}
                otherStyles={"bg-brandGreen text-white w-full text-center"}
                destination={`/donate/${campaignReference}/${encodeURIComponent(
                  campaignDetail?.title
                )}`}
              />
            </div>
            <div
              onClick={showShareOptions}
              className="text-sm flex items-center font-medium py-6 px-8 md:p-4 rounded text-white bg-secondary/20 cursor-pointer"
            >
              <img src={share} alt="" className="h-4" />
            </div>
          </div>
        </div>

        {/* Campaign updates modal */}
        {showUpdatesModal && (
          <CampaignUpdates updates={updates} onClose={closeUpdates} />
        )}

        {/* Share campaign modal */}
        {ShareModal && <ShareCampaign onClose={closeShareOptions} />}
      </div>
    );
}
 
export default CampaignDetail;